<template>
    <b-dropdown class="cart-dropdown" mobile-modal position="is-bottom-left">
        <a class="navbar-item cart" slot="trigger">
            <span class="icon is-large">
                <i class="fal fa-shopping-cart fa-lg"></i>
            </span>

            <span class="badge" :data-count="count" v-if="count > 0"></span>

            <span class="is-hidden-mobile total">{{ total | toCurrency }}</span>
        </a>

        <div class="cart-content">
            <div class="cart-list" v-if="count > 0">
                <b-dropdown-item custom v-for="item in items" :product="item" :key="item.id">
                    <article class="media">
                        <figure v-if="item.product.thumbnail" class="media-left">
                            <p class="image is-64x64">
                                <img class="thumbnail" :src="item.product.thumbnail | toCDNPath"/>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <h1 class="product-title" :class="{ 'has-text-danger': !hasStock(item) }">{{ item.product.name | toLowercase }}<span v-if="!hasStock(item)"> (Sin stock)</span></h1>
                                <span class="product-price has-text-primary">{{ item.product.price | toCurrency }}</span>
                                <br/>

                                <span class="icon" @click="onMinusClicked(item)">
                                    <i class="fas fa-minus"></i>
                                </span>

                                <span>{{ item.quantity }}</span>

                                <span class="icon" @click="onPlusClicked(item)">
                                    <i class="fas fa-plus"></i>
                                </span>
                                
                                <span class="icon" @click="onDeleteClicked(item)">
                                    <i class="fas fa-trash-alt"></i>
                                </span>
                            </div>
                        </div>
                    </article>
                </b-dropdown-item>
            </div>
            <div v-else>
                <b-dropdown-item>
                    <p>Tu carrito esta vacio</p>
                </b-dropdown-item>
            </div>

            <template v-if="count > 0">
                <div class="cart-footer">
                    <b-dropdown-item custom>
                        <div class="level is-mobile">
                            <div class="level-left"><span class="has-text-weight-bold">Total</span></div>
                            <div class="level-right">
                                <span class="has-text-weight-bold has-text-primary">{{ total | toCurrency }}</span>
                            </div>
                        </div>

                        <template v-if="cartHasError('error.order.total_below_minimum_sale')">
                            <div class="level is-mobile">
                                <div class="level-left"><span class="has-text-weight-bold has-text-danger">Pedido Mínimo</span></div>
                                <div class="level-right">
                                    <span class="has-text-weight-bold has-text-danger">{{ minSale | toCurrency }}</span>
                                </div>
                            </div>
                        </template>

                        <template v-if="cartHasError('error.order.out_of_stock')">
                            <span class="has-text-danger error-text">Algunos productos en tu carrito no cuentan con stock disponible</span>
                        </template>

                        <template v-if="minFreeShipping - total > 0">
                            <div class="level is-mobile free-shipping">
                                <span>Agregá {{(minFreeShipping - total) | toCurrency }} más y te bonificamos el costo de envio</span>
                            </div>
                        </template>

                        <div class="level is-mobile">
                            <button class="button is-primary is-medium" v-on:click="onCheckout" :disabled="!cartCanCheckout">
                                PAGAR
                            </button>
                        </div>
                    </b-dropdown-item>
                </div>
            </template>
        </div>
    </b-dropdown>
</template>

<script>
    export default {
        name: 'CartMenu',
        data() {
            return {}
        },
        computed: {
            items() {
                let cart = this.$store.getters['cart/get']();

                return cart ? cart.items.filter(ci => ci.product.type === 'product') : [];
            },

            count() {
                return this.$store.getters['cart/count'];
            },

            total() {
                let cart = this.$store.getters['cart/get']();

                return cart ? cart.subtotal : 0;
            },

            minSale() {
                return this.$store.getters['parameters/get']('order.min_sale');
            },

            minFreeShipping() {
                return this.$store.getters['parameters/get']('order.free_shipping');
            },

            cartCanCheckout() {
                return !this.cartHasError('error.order.total_below_minimum_sale') && 
                    !this.cartHasError('error.order.out_of_stock');
                
            }
        },
        
        mounted() {

        },

        methods: {
            hasStock(item) {
                let currentStock = this.$store.getters['cart/getStock'](item.product.id);
                return item.quantity <= currentStock;
            },

            cartHasError(error) {
                let cart = this.$store.getters['cart/get']();
                return cart.errors ? cart.errors.includes(error) : false;
            },

            onMinusClicked(item) {
                this.$store.dispatch('cart/remove', {
                    item: {
                        product: item.product.id,
                        quantity: 1
                    }
                });
            },

            onPlusClicked(item) {
                this.$store.dispatch('cart/add', {
                    item : {
                        product: item.product.id,
                        quantity: 1
                    }
                });
            },

            onDeleteClicked(item) {
                this.$store.dispatch('cart/remove', {
                    item: {
                        product: item.product.id,
                        quantity: item.quantity
                    }
                });
            },

            async onCheckout() {
                if(this.total >= this.minSale) {
                    if(!this.$store.getters['user/isAuthenticated']) {
                        await this.$router.push({ path: '/login?redirect=/checkout'}).catch(err => {});
                    }
                    else {
                        await this.$router.push({name: 'Checkout'}).catch(err => {});
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    article {
        width: 240px;
    }

    .cart-content {
        display: flex;
        flex-flow: column;
        max-height: 80vh;

        .cart-footer {
            flex: 0 1 auto;

            .level {
                margin: 0px 0px 10px;
            }

        }

        .cart-list {
            flex: 1 1 auto;

            // @media screen and (max-height: 500px) {
            //     display: none;
            // }

            border-bottom: 1px solid lightgray;
            overflow-y: auto;

            .image {
                .thumbnail {
                    max-height: none !important;
                }
            }

            .product-title {
                font-size: 0.8rem;
                text-transform: capitalize;
                margin-bottom: 0px !important;
            }

            .product-price {
                font-size: 0.8rem;
            }
        }
    }


    .cart {
        position: relative;

        .total {
            color: white;
        }

        .badge {
            position: absolute;

            top: 10px;
            left: 40px;
        }

        .badge[data-count]:after {
            content: attr(data-count);
            position: absolute;
            top: 0;
            left: 0;

            font-size: 0.8em;
            background-color: $primary;
            color: white;
            width: 18px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            border-radius: 50%;
            box-shadow: 0 0 1px #333;
        }
    }

    .black {
        .cart {
            .icon {
                color: black;
            }

            .total {
                color: black;
            }
        }
    }

    .free-shipping {
        background-color: $primary;
        padding: 10px;
        border-radius: 10px;

        span {
            color: white;
            font-size: 0.9em;
            text-transform: none;
        }
    }

    .error-text {
        font-size: 0.9em;
        text-transform: none;
        margin-bottom: 10px;
        display: block;
    }
</style>